const navegacaoSubnivel = (state) => {
  return state.navegacaoSubnivel
}

export { navegacaoSubnivel }
